import { render, staticRenderFns } from "./exhibition-info-fasciaBoardAlter.vue?vue&type=template&id=4c556757&scoped=true&"
import script from "./exhibition-info-fasciaBoardAlter.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-fasciaBoardAlter.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-fasciaBoardAlter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-info-fasciaBoardAlter.vue?vue&type=style&index=1&id=4c556757&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c556757",
  null
  
)

export default component.exports